import "./styles.scss";

const CustomBox = ({ children, className = "", style = {}, ...props }) => {
  return (
    <div className={`custom-box ${className}`} style={style} {...props}>
      {children}
    </div>
  );
};

export default CustomBox;
